import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { TrackingCaseDocumentEditForm } from "application/tracking-case/forms";
import { TrackingCaseDocumentService, DocumentTypeService, DocumentFormService } from "application/tracking-case/services";
import { action } from "mobx";

class TrackingCaseDocumentEditModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const service = new TrackingCaseDocumentService(rootStore.application.baasic.apiClient);
        const documentTypeService = new DocumentTypeService(rootStore.application.baasic.apiClient);
        const documentFormService = new DocumentFormService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: "trackingCaseDocument",
            id: componentProps.modalParams.data.id,
            actions: {
                get: async id => {
                    const response = await service.get(id, {embed: "documentType,documentForm"});

                    this.form.update(response.data);
                    return response.data;
                },
                // update: async resource => {
                //     const response = await service.update(resource);
                //     return response.data;
                // },
                create: async resource => {
                    resource.trackingCaseId = this.componentData.trackingCaseId;

                    const response = await service.create(resource);
                    return response.data;
                },
            },
            errorActions: {
                onCreateError: ({ error }) => {
                    rootStore.notificationStore.error('TRACKING_CASE_DOCUMENT.CREATE.ERROR', error);
                },
                // onUpdateError: ({ error }) => {
                //     rootStore.notificationStore.error('TRACKING_CASE_DOCUMENT.EDIT.ERROR', error);
                // },
            },
            FormClass: TrackingCaseDocumentEditForm,
        });

        this.service = new TrackingCaseDocumentService(rootStore.application.baasic.apiClient);
        this.documentTypeService = documentTypeService;
        this.documentFormService = documentFormService;

        this.componentProps = componentProps;
        this.componentData = componentProps && componentProps.modalParams.data;

        this.documentTypeStore = new BaasicDropdownStore(
            {
                filterable: true
            },
            {
                fetchFunc: async (term) => {
                    let params = {
                        fields: "id,name",
                        rpp: 50,
                        keyword: term
                    };

                    const response = await this.documentTypeService.find(params);
                    return response.data.item;
                },
                onChange: async (documentTypeId) => {
                    this.form.set({ documentTypeId: documentTypeId });

                    this.form.set({ documentFormId: null });
                    this.documentFormStore.setValue(null);
                    await this.documentFormStore.filterAsync();
                }
            }
        );

        this.documentFormStore = new BaasicDropdownStore(
            {
                filterable: true,
                initFetch: false
            },
            {
                fetchFunc: async (term) => {
                    if(this.documentTypeStore.value == null){
                        return [];
                    }

                    let params = {
                        fields: "id,name",
                        rpp: 50,
                        keyword: term,
                        documentTypeId: this.documentTypeStore.value.id
                    };

                    const response = await this.documentFormService.find(params);
                    return response.data.item;
                }
            }
        );
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            if (this.componentData == null) {
                await this.rootStore.routerStore.goBack();
            } else
            {
                this.componentProps.modalParams.close();
                this.componentProps.modalParams.data.fetchTable();
            }

            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('TRACKING_CASE_DOCUMENT.CREATE.SUCCESS');
    }
}

export default TrackingCaseDocumentEditModalStore;
